import React from 'react';
import { Flex, Box, Text } from '@radix-ui/themes';
import './style.scss';

// 메인 페이지
export default function Main() {
  return (
    <Flex align="center" justify="center" className="main-welcome-container">
      <Box className="main-welcome-content">
        <Text as="div" size="4" weight="medium" className="main-brand">
          NIPA Dreams Solution Bank
        </Text>

        <Text as="h1" size="9" weight="bold" className="main-title">
          지역 혁신의 새로운 시작
        </Text>

        <Text as="p" size="5" className="main-description">
          솔루션 뱅크와 함께 디지털 기술을 활용한 지역사회 문제해결에 참여하세요.
        </Text>

        <Text as="p" size="4" className="main-sub-description">
          더 나은 지역사회를 만들어가는 여정에 동참해주세요.
        </Text>

        <Box className="main-features">
          <Box className="feature-item">
            <Box className="feature-icon">🚀</Box>
            <Text size="3" weight="medium">
              혁신적 솔루션
            </Text>
          </Box>
          <Box className="feature-item">
            <Box className="feature-icon">🤝</Box>
            <Text size="3" weight="medium">
              지역사회 협력
            </Text>
          </Box>
          <Box className="feature-item">
            <Box className="feature-icon">💡</Box>
            <Text size="3" weight="medium">
              디지털 전환
            </Text>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
}
